import { Tooltip, makeStyles, shorthands, MenuButton, mergeClasses } from '@fluentui/react-components';
import { ReactNode, forwardRef } from 'react';
import { TIcon } from '@shared/types';
import useEditorActive from '../../../hooks/useEditorActive.hook';
import { isLockedOutsideFields } from '../../../tiptap/extensions/TemplateLocking';
import useToolbarButtonStyles from '../../../hooks/useToolbarButtonStyles.hook';

const useStyles = makeStyles({
  root: {
    fontWeight: 'normal',
    alignItems: 'flex-start',
    '& .fui-MenuButton__menuIcon': {
      fontSize: '15px',
    },

    ...shorthands.borderColor('transparent'),
    minWidth: 0,
    padding: '5px 5px',
  },
});

type TProps = {
  tooltip?: any;
  icon?: TIcon | null;
  menuIcon?: TIcon | null;
  disabled?: boolean;
  children?: ReactNode;
  onClick?: (e?: any) => unknown;
  className?: string;
};

const ToolbarMenuButton = forwardRef<HTMLButtonElement, TProps>(
  (
    {
      tooltip = null,
      icon = null,
      menuIcon = undefined,
      disabled = false,
      children = null,
      onClick = undefined,
      className = '',
    },
    ref
  ) => {
    const classes = useStyles();
    const toolbarClasses = useToolbarButtonStyles();

    // Central gate: the locked body of a bound document silently filters every edit.
    const lockDisabled = useEditorActive((e) => isLockedOutsideFields(e.state));
    const isDisabled = disabled || lockDisabled;

    if (!children) {
      // @ts-ignore
      children = icon;
      icon = null;
    }

    const content = (
      <MenuButton
        icon={icon}
        menuIcon={menuIcon}
        className={mergeClasses(classes.root, isDisabled && toolbarClasses.disabled, className)}
        disabled={isDisabled}
        onClick={onClick}
        ref={ref}
      >
        {children}
      </MenuButton>
    );

    if (!tooltip) return content;

    return (
      <Tooltip content={tooltip} relationship="label" withArrow>
        {content}
      </Tooltip>
    );
  }
);

export default ToolbarMenuButton;
